import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'SignInPage',
        path: () => path.join(__dirname, './SignInPage'),
        resolve: () => require.resolveWeak('./SignInPage'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "SignInPage" */ './SignInPage')]).then(
                (proms) => proms[0]
            ),
    })
);
